<template>
    <paper>
        <m-pane
            ref="tablePage"
            :config="config"
            :totalData="totalData"
            :pageTotal="pageTotal"
            :loading="loading"
            :searchTotalTitle="searchTotalTitle"
            @searchChange="searchChange"
            @pageChange="pageChange"
            @sizeChange="sizeChange"
            @del-btn="delBtn"
            @edit-btn="editBtn"
            @enable-btn="enableBtn"
            @disable-btn="disableBtn"
            @btnClick="btnClick"
            searchId="sieveSingleRule"
            pageID="sieveSingleRule"
            class="sieve-single-rule"
        >
            <span slot="search-list-advance-right">
                 <el-button class="reset"  @click="reset">重 置</el-button>
            </span>
           <div slot="page-module-btn">
                <el-button v-has="'otp02050001'" type="primary" @click="addNewRule">新建规则</el-button>
            </div>
        </m-pane>
          <edit-dialog v-if="editDialogVisible"  :dialogVisible.sync="editDialogVisible"  :title="title"
          :rowData="rowData" @handleClose="handleClose"></edit-dialog>
    </paper>
</template>
<script>
import mPane from '@/components/otpPanel';
import config from './config.js';
import paper from '@/components/core/paper/Paper';
import EditDialog from './component/EditDialog';
import { getSearchList, deleteByIds, saveDate } from '../../../api/sieveSingleRule';

export default {
    name: 'sieveSingleRule',
    components: { mPane, paper, EditDialog },
    data() {
        return {
            config: config,
            totalData: [],
            loading: false,
            editDialogVisible: false,
            pageTotal: 0,
            searchTotalTitle: config.searchTotalTitle,
            title: '新建规则',
            searchParams: {
                pageSize: 10,
                pageNo: 1
            },
            rowData: {}
        };
    },
    methods: {
        reset() {
            this.$refs.tablePage.$refs.searchList.dataInit(null, true);
        },
        addNewRule() {
            this.title = '新建规则';
            this.editDialogVisible = true;
        },
        handleClose(val) {
            if (val) {
                this.getList();
            }
            this.editDialogVisible = false;
        },
        getList() {
            this.loading = true;
            getSearchList(this.searchParams).then(res => {
                if (res && +res.code === 0) {
                    this.totalData = res.data.list || [];
                    this.totalData.forEach(item => {
                        item.hiddenEvent = [];
                        if (+item.isUse === 1) {
                            item.isUseName = '否';
                            item.hiddenEvent = ['disable'];
                        } else {
                            item.isUseName = '是';
                            item.hiddenEvent = ['edit', 'enable', 'del'];
                        }
                    });
                    this.pageTotal = res.data.totalCount;
                }
            }).finally(() => {
                this.loading = false;
            });
        },
        delBtn(row) {
            this.$confirm('确定删除该规则?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                deleteByIds(row.id).then(res => {
                    if (res && +res.code === 0) {
                        this.$message.success('删除成功');
                        this.getList();
                    }
                });
            });
        },
        editBtn(rowData) {
            this.title = '编辑规则';
            this.rowData = rowData;
            this.editDialogVisible = true;
        },
        btnClick(val, index, rowData) {
            this.title = '查看规则';
            this.rowData = rowData;
            this.editDialogVisible = true;
        },
        enableBtn(rowData) {
            rowData.isUse = 0;
            this.handleSave(rowData, '启用成功');
        },
        disableBtn(rowData) {
            rowData.isUse = 1;
            this.handleSave(rowData, '停用成功');
        },
        handleSave(rowData, message) {
            saveDate(rowData).then(res => {
                if (res && +res.code === 0) {
                    this.$message.success(`${message}`);
                    this.getList();
                }
            });
        },
        searchChange(data) {
            this.searchParams = {
                ...this.searchParams,
                ...data
            };
            this.getList();
        },
        pageChange(data) {
            // 分页器页数变化
            this.searchParams.pageNo = data;
            this.getList();
        },
        sizeChange(data) {
            // 分页器页数大小变化
            this.searchParams.pageSize = data;
            this.searchParams.pageNo = 1;
            this.getList();
        }
    },
    mounted() {
        this.getList();
    }
};
</script>
<style lang="less">
.sieve-single-rule{
    .reset{
        margin-left: 10px;
    }
}
</style>
